import React from 'react'

import { Element, ElementProps, Image, Text } from "components/shared/base"
import { mapColumnSize } from "utils"
import {
  PrismicHomepageDataBodyImageAndTextItem
} from "types/__generated__/gatsby-graphql"
import useBreakpoints from "src/hooks/useBreakpoints"

interface OwnProps {
  item: PrismicHomepageDataBodyImageAndTextItem
}

export type ImageAndTextItemProps = OwnProps & Omit<ElementProps, "errors">

const ImageAndTextItem: React.FC<ImageAndTextItemProps> = ({
  item: {
    icon = {},
    image = {},
    mobile_image = {},
    text,
    title,
    title_width
  },
  ...elementProps
}): React.ReactElement | null => {
  const titleText = title?.text || "";
  const imageCheck = image?.alt && image?.gatsbyImageData;

  if (!titleText && !imageCheck && !text) {
    return null;
  }

  const titleColumnSize = mapColumnSize(title_width);
  const { breakpoint } = useBreakpoints()
  const isIconNotEmpty = icon?.gatsbyImageData ? true : false;

  let imageData = {};

  if (breakpoint === "sm" && mobile_image?.gatsbyImageData) {
    imageData = {
      alt: mobile_image.alt || image.alt,
      gatsbyImageData: mobile_image.gatsbyImageData
    }
  } else {
    imageData = image;
  }

  return (
    <Element
      {...elementProps}
      alignSelf="center"
      gridColumnGap="25px"
      pt={isIconNotEmpty ? ["75px", "75px", '0']: "0"}
    >
      {imageCheck && (
        <Element fontSize="0px">
          <Image alt={imageData?.alt} image={imageData?.gatsbyImageData} max-width="100%" />
        </Element>
      )}
      {isIconNotEmpty && (
        <Element fontSize="0px" mb="35px">
          <Image alt={icon?.alt} image={icon?.gatsbyImageData} width="auto" />
        </Element>
      )}
      {titleText && (
        <Element display="grid" gridTemplateColumns="repeat(12, 1fr)">
          <Text
            as="h3"
            fontSize={["text.titleMobile", "text.titleMobile", "text.titleMobile", "text.title"]}
            gridColumnEnd={titleColumnSize.gridColumnEnd}
            gridColumnStart={titleColumnSize.gridColumnStart}
            lineHeight="primary">
              {titleText}
          </Text>
        </Element>
      )}
      {text && (
        <Text
          fontSize={["text.primaryMobile", "text.primary"]}
          lineHeight="164%"
          mt={titleText ? "30px": '0'} >
            {text}
        </Text>
      )}
    </Element>
  )
}

export default ImageAndTextItem
